import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { firestore } from '../firebase';
import { subscribeSharedFirestore } from './sharedFirestoreSubscription';

export function subscribeTodayAttendance({ date, role, userId, onData, onError }) {
  const normalizedRole = String(role || '').toLowerCase();
  if (!date || !['admin', 'partner', 'staff'].includes(normalizedRole)) {
    onData([]);
    return () => {};
  }

  const attendanceCollection = collection(firestore, 'attendance');
  const attendanceQuery = normalizedRole === 'staff'
    ? query(attendanceCollection, where('userId', '==', userId), where('date', '==', date))
    : query(attendanceCollection, where('date', '==', date));
  const key = normalizedRole === 'staff'
    ? `attendance:${date}:staff:${userId}`
    : `attendance:${date}:all`;

  return subscribeSharedFirestore({
    key,
    onData,
    onError,
    start: (emit, emitError) => onSnapshot(
      attendanceQuery,
      (snapshot) => emit(snapshot.docs.map((item) => ({ id: item.id, ...item.data() }))),
      emitError
    ),
  });
}
